import { createSaga } from './saga-helpers';

import * as Api from '../api/connected-calendars-api';

const watchGetConnectedCalendars = createSaga({
    type: 'CONNECTED_CALENDARS_FETCH',
    fn: Api.fetchConnectedCalendars,
    args: action => [action.payload],
    successPayload: ({ calendars, hasMore } = {}, action) => ({
        calendars,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchAddConnectedCalendars = createSaga({
    type: 'CONNECTED_CALENDARS_ADD',
    fn: Api.addConnectedCalendars,
    args: action => [action.payload.calendars],
    successPayload: calendar => ({ calendar })
});

const watchRemoveConnectedCalendars = createSaga({
    type: 'CONNECTED_CALENDARS_REMOVE',
    fn: Api.removeConnectedCalendars,
    args: action => [action.payload.calendars]
});

const sagas = [watchGetConnectedCalendars, watchAddConnectedCalendars, watchRemoveConnectedCalendars];

export default sagas;
